<template>
  <Teleport to="body">
    <iModal
      primary-action-button-label="Save"
      :primary-action-button-loading="isLoading"
      :primary-action-button-disabled="!name"
      :visible="open"
      :max-width="750"
      :title="modalTitle"
      @close="closeModal"
      @click:primary="submit"
    >
      <template #body>
        <iColumn>
          <iRow gap="extraLarge" vertical-align="middle">
            <iRow>
              <iText font-size="standard">
                Cover Image
              </iText>
            </iRow>

            <iImageContainer :src="imageSrc" :height="100" />
            <iUploader @upload-file="(image) => uploadCoverImage(image, collectionId)">
              <iButton
                variant="secondary"
                size="small"
                :is-loading="isUploadingCoverImage"
                :disabled="isUploadingCoverImage"
              >
                {{ coverImage ? "Change" : "Select" }} Image
              </iButton>
            </iUploader>
          </iRow>
          <iRow gap="extraLarge">
            <iTextInput v-model="name" placeholder="Fall Outfits" label="Name" />
          </iRow>
          <iColumn gap="extraLarge">
            <iTextArea v-model="description" placeholder="Ideas to post Labor Day - Thanksgiving" label="Description" />
            <iRow gap="extraLarge">
              <iRadioButton v-model="visibility" value="public" label="Public" />
              <iRadioButton v-model="visibility" value="private" label="Private" />
            </iRow>
          </iColumn>
        </iColumn>
      </template>
    </iModal>
  </Teleport>
</template>
<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { DEFAULT_COLLECTION_COVER_IMAGE } from "@/constants/affiliate-constants";
import { useCollectionStore } from "~/stores/collection-store";
import { useCollectionFeedStore } from "SmartFeed/stores/feed/collection-feed-store";

export default {
  name: "CollectionCreateUpdateModal",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    collection: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  emits: ["close", "save"],
  data() {
    return {
      name: "",
      category: "",
      description: "",
      coverImage: "",
      coverImageUpload: null,
      visibility: "public",
      DEFAULT_COLLECTION_COVER_IMAGE,
    };
  },
  computed: {
    ...mapState(useCollectionStore, [
      "isLoading",
      "isUploadingCoverImage",
    ]),
    ...mapState(useCollectionFeedStore, [
      "metadata",
    ]),
    ...mapWritableState(useCollectionStore, ["uploadedCoverImage"]),
    collectionId() {
      if (typeof this.collection === "object" && "collectionId" in this.collection) {
        return this.collection.collectionId;
      }

      return 0;
    },
    isEditContext() {
      return this.collectionId > 0;
    },
    modalTitle() {
      if (this.isEditContext) {
        return "Edit Collection";
      }
      return "Create Collection";
    },
    imageSrc() {
      if (this.coverImage) {
        return this.coverImage;
      } else {
        return this.DEFAULT_COLLECTION_COVER_IMAGE;
      }
    },
  },
  watch: {
    uploadedCoverImage(newValue) {
      if (newValue) {
        this.coverImage = newValue;
        this.uploadedCoverImage = null;
      }
    },
  },
  created() {
    if (this.isEditContext) {
      this.name = this.collection.name;
      this.description = this.collection.description;
      this.coverImage = this.collection.coverImageUrl;
      this.visibility = this.collection.visibility;
    }
  },
  methods: {
    ...mapActions(useCollectionStore, [
      "createCollection",
      "updateCollection",
      "uploadCoverImage",
    ]),
    closeModal() {
      this.$emit("close");
    },
    getRequestBody() {
      return {
        name: this.name,
        description: this.description,
        cover_image_url: this.imageSrc,
        visibility: this.visibility,
        item_id: this.metadata.itemId,
        item_context: this.metadata.itemContext,
      };
    },
    submit() {
      if (!this.name) {
        return;
      }
      if (this.isEditContext) {
        this.updateCollection(this.collection.collectionId, this.getRequestBody()).then(() => {
          this.$emit("save");
          this.closeModal();
        });
      } else {
        this.createCollection(this.getRequestBody()).then(() => {
          this.$emit("save");
          this.closeModal();
        });
      }
    },
  },
};
</script>
